import { atom } from 'jotai'
import { QueryHistoryEntry } from './queryHistoryStorage'

export const queryHistoryAtom = atom<QueryHistoryEntry[]>([])
